<p-floatlabel>
  <p-fluid>
    <input type="text" [id]="'text-search-filter-element-' + inputId" pInputText [(ngModel)]="value" (change)="onFilterChange($event)"/>
  </p-fluid>
  @if(label) {
    <label [for]="'text-search-filter-element-' + inputId">{{label | translate}}</label>
  }
</p-floatlabel>